module.exports = __webpack_public_path__ + "img/arrow-right-purple.a3001e1f9a4d1ef1e0ee2c7a5d744b70.svg";